var render, staticRenderFns
import script from "./mangaReloadFormBaseLogic.vue?vue&type=script&lang=js&"
export * from "./mangaReloadFormBaseLogic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d22ee8c",
  null
  
)

export default component.exports